import { inject } from "@vue/composition-api";
import { ErrorsContext } from '../contexts';

const useErrors = () => inject(ErrorsContext)

export default useErrors